export enum PermanentOrganization {
  AUTOPAY = 'AUTOPAY',
  CHECKLIGHT = 'CHECKLIGHT',
  CONSUMER_PORTAL = 'CONSUMER_PORTAL',
}
